import { AuthScene } from '../scenes/auth';

export let Login = () => {
  return <AuthScene type="login" />;
};
